<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3>{{(colorID ? 'nav.datasets.colors.edit' : 'nav.datasets.colors.create') |translate }}</h3>
              <div class="row mt-5">
                <div class="col col-md-6">
                  <div class="form-group validateMe d-block">
                    <label class="form-label"
                           for="Color">{{'lang.globals.color' | translate}}<span class="red">*</span></label>
                    <div id="Color" class="d-flex cursor-pointer">
                      <input type="text" class="form-control"
                             formControlName="Color">
                      <div #colorPickerElement
                           class="ml-3 cp border-box d-flex align-items-center justify-content-center"
                           [style.backgroundColor]="'#' +color?.color"
                           (colorPickerSelect)="setColor($event)"
                           (cpPresetColorsChange)="colorService.setColor($event)"
                           [colorPicker]="'#' +color?.color"
                           [cpAlphaChannel]="'disabled'"
                           [cpCloseClickOutside]="true"
                           [cpOKButtonClass]="'btn btn-primary'"
                           [cpOKButtonText]="'lang.globals.addColor' | translate"
                           [cpOKButton]="true"
                           [cpOutputFormat]="'hex'"
                           [cpSaveClickOutside]="false"
                           [cpUseRootViewContainer]="false"
                           [cpWidth]="'255px'">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control"
                           formControlName="Name">
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">
                      {{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col">
                  <div class="form-group validateMe">
                    <label class="form-label"
                           for="Description">{{'lang.globals.description' | translate}}</label>
                    <input type="text" id="Description" class="form-control"
                           formControlName="Description">
                  </div>
                </div>

              </div>
              <div class="wizard__footerActions">
                <button (click)="cancel()"
                           class="btn btn-default btn-lg btn-wide">
                  {{'lang.globals.cancel' | translate}}
                </button>
                <button *ngIf="!color?.global" (click)="submit()" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">
                  {{'lang.globals.submit' | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
